var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"sobreNos"}},[_c('BannerImagem',{attrs:{"image":_vm.conteudo.banner}}),_c('TituloPagina',{attrs:{"titulo":_vm.conteudo.titulo}}),_c('NossaHistoria'),_c('Parceiros'),_c('Instituto'),(_vm.$store.state.asideVideo != null)?_c('AsideVideo'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }